import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import type {
  ButtonTextColorMode,
  SolidButtonLinkProps,
} from '@noths/polaris-client-ribbons-design-system';
import { SolidButtonLink } from '@noths/polaris-client-ribbons-design-system';

import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import { trackImpression } from 'src/tracking/common/trackImpression';
import { trackLinkClick } from 'src/tracking/components/button';
import type { TrackingContext } from 'src/types/TrackingContext';
import * as styles from './ButtonSection.styles';

export interface ButtonSectionProps
  extends Omit<SolidButtonLinkProps, 'compact' | 'fullWidth' | 'loading'> {
  trackingPosition?: number;
  trackingTitle: string;
}

export const ButtonSection = ({
  trackingPosition,
  trackingTitle,
  ...restOfProps
}: ButtonSectionProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'CTA button',
  };
  const { observedElementRef: buttonRef } = useVisibilityObserver(() =>
    trackImpression(trackingContext),
  );

  return (
    <SectionContainer columnsXL={10} maxWidth="full" ref={buttonRef} wrapperStyles={styles.wrapper}>
      <SolidButtonLink
        {...restOfProps}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => trackLinkClick(e, trackingContext)}
      />
    </SectionContainer>
  );
};

export type { ButtonTextColorMode };
